import { STATUS } from "~~/constant/tracking.constant";

export const eventDriverType = {
    'live_tracking.driver.login.1.0.0': 205,
    'live_tracking.driver.logout.1.0.0': 204,
    'live_tracking.driver.stationary.1.0.0': 201,
    'live_tracking.driver.moving.1.0.0': 208,
    'live_tracking.driver.gps_on.1.0.0': 203,
    'live_tracking.driver.gps_off.1.0.0': 202,
    'live_tracking.driver.stop.1.0.0': 207,
    'live_tracking.shipment.on_delivery.1.0.0': 1109,
    'live_tracking.shipment.second_attempt.1.0.0': 1108,
    'live_tracking.shipment.arrived.1.0.0': 1110,
    'live_tracking.shipment.pod.1.0.0': 1104,
    'live_tracking.shipment.back_to_store': 1204,
    'live_tracking.shipment.request_pod.1.0.0': 1401,
    'live_tracking.shipment.approved_pod.1.0.0': 1402,
    'live_tracking.shipment.rejected_pod.1.0.0': 1403,
    'live_tracking.shipment.refund_request.1.0.0': 1301,
    'live_tracking.shipment.refund_approved.1.0.0': 1302,
    'live_tracking.shipment.refund_rejected.1.0.0': 1306,
    'live_tracking.shipment.auto_cancel_cod.1.0.0': 1105
};


export const STATUS_MAP: Record<number, string> = {
    // Trip Statuses (Contoh)
    [STATUS.TRIP.readyDeliverTripStatus]: "Siap Dikirim",                 // 1206
    [STATUS.TRIP.onDeliverTripStatus]: "Dikirim",                         // 1207
    [STATUS.TRIP.completedTripStatus]: "Selesai",                         // 1204
    [STATUS.TRIP.pendinTripStatus]: "Pending",                            // 1208
    [STATUS.TRIP.deleteTripStatus]: "Trip Dihapus",                       // 1205

    // Order/Shipment Statuses (Contoh dari STATUS.ORDER)
    [STATUS.ORDER.newOrderStatus]: "Order Baru",                          // 1101
    [STATUS.ORDER.packingOrderStatus]: "Order Dikemas",                   // 1102
    [STATUS.ORDER.readyOrderStatus]: "Order Siap Ambil",                  // 1103
    [STATUS.ORDER.completedOrderStatus]: "Selesai",                       // 1104 (POD Berhasil juga bisa)
    [STATUS.ORDER.cancelOrderStatus]: "Order Dibatalkan",                 // 1105
    [STATUS.ORDER.readyDeliverOrderStatus]: "Order Siap Dikirim",         // 1106
    [STATUS.ORDER.onDeliverOrderStatus]: "Order Sedang Dikirim",          // 1107
    [STATUS.ORDER.sacondAttemptOrderStatus]: "Upaya Kedua",               // 1108
    [STATUS.ORDER.untilDestinationStatus]: "Tiba di Tujuan",              // 1110

    // Driver Statuses (Contoh dari STATUS.DRIVER)
    [STATUS.DRIVER.availableDriverStatus]: "Available",                   // 301
    [STATUS.DRIVER.onDeliverDariverStatus]: "Sedang Mengirim",            // 302
    [STATUS.DRIVER.onTransitDriverStatus]: "Sedang Transit",              // 303
    [STATUS.DRIVER.headingToStoreStatus]: "Kembali ke Toko",              // 304
};

export const ACTIVITY_STATUS_MAP: Record<number, string> = {
    [STATUS.DRIVER.headingToStoreStatus]: "Rider kembali ke toko",

    [STATUS.HISTORY_TRACK.idleStatus]: "Rider tidak bergerak",  // 201
    [STATUS.HISTORY_TRACK.gpsOfStatus]: "GPS tidak aktif",      // 202
    [STATUS.HISTORY_TRACK.gpsOnStatus]: "GPS kembali aktif",    // 203
    [STATUS.HISTORY_TRACK.logoutStatus]: "Rider logout akun",   // 204
    [STATUS.HISTORY_TRACK.loginStatus]: "Rider login akun",     // 205
    [STATUS.HISTORY_TRACK.stopStatus]: "Rider kembali ke toko",  // 207
    [STATUS.HISTORY_TRACK.backToMoveStatus]: "Rider kembali bergerak",  // 208

    [STATUS.ORDER.completedOrderStatus]: "POD pesanan",
    [STATUS.ORDER.sacondAttemptOrderStatus]: "menunda pengiriman pesanan",
    [STATUS.ORDER.tripActivityShipmentOnDelivery]: "mengantar pesanan",
    [STATUS.ORDER.untilDestinationStatus]: "sampai ditujuan",
    [STATUS.ORDER.cancelOrderStatus]: "dibatalkan otomatis",


    [STATUS.POD_OUT_OF_COORDINATE.PODOutOfCoordinateRequest]: "mengajukan POD pesanan",
    [STATUS.POD_OUT_OF_COORDINATE.PODOutOfCoordinateApproved]: `disetujui`,
    [STATUS.POD_OUT_OF_COORDINATE.PODOutOfCoordinateRejected]: `ditolak`,

    [STATUS.REFUND.refundRequest]: "mengajukan refund pesanan",
    [STATUS.REFUND.refundApproved]: "disetujui",
    [STATUS.REFUND.refundRejected]: "ditolak",
    [STATUS.REFUND.refundCompleted]: "refund completed"

};

export function getStatusText(statusCode: number): string {
    return STATUS_MAP[statusCode] || `Status Unknown`;
}

export function getStatusTextActivity(statusCode: number, name?: string): string {
    const statusText = ACTIVITY_STATUS_MAP[statusCode] || 'Status Unknown';

    if (name) {
        return statusText.replace('[nama]', name);
    }
    if (name === undefined) {
        return statusText.replace('[nama]', '');
    }

    return statusText;
}

export function mapApiDriverStatusToNumeric(apiStatusString: string): number | undefined {
    const normalizedStatus = apiStatusString.toLowerCase();

    switch (normalizedStatus) {
        case 'available':
            return STATUS.DRIVER.availableDriverStatus;
        case 'on_delivery':
            return STATUS.DRIVER.onDeliverDariverStatus;
        case 'on_transit':
            return STATUS.DRIVER.onTransitDriverStatus;
        case 'back_to_store':
            return STATUS.DRIVER.headingToStoreStatus;
        default:
            return undefined;
    }
}

